// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ycvT","title":"styles_title__1mEwG"};